module.exports = __webpack_public_path__ + "img/charis-presets_banner.27234e1f.jpg";